<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <aside
    :class="{ 'c-sidebar--preview-mode': showPreviewTheme }"
    class="c-sidebar"
  >
    <div
      :class="{
        'c-sidebar__scroll-wrapper--space-top':
          customizationSelected && lengthCustomizations !== 1,
      }"
      class="c-sidebar__scroll-wrapper"
    >
      <nav
        :class="{
          'c-sidebar__nav--fixed':
            customizationSelected && lengthCustomizations !== 1,
        }"
        class="c-sidebar__nav"
      >
        <ul class="c-sidebar__list">
          <li class="c-sidebar__list-item is-hidden-tablet">
            <a
              @click.prevent="togglePreviewMode"
              class="c-sidebar__list-link"
              href="#"
            >
              <base-icon width="24" height="24" name="painel/show-icon" />
              <span class="c-sidebar__list-label">
                <strong>Visualizar site</strong>
              </span>
            </a>
          </li>
          <li
            v-if="customizationSelected && lengthCustomizations !== 1"
            class="c-sidebar__list-item c-sidebar__list-item--header"
          >
            <a
              @click.prevent="showCustomization(null)"
              class="c-sidebar__list-link"
              href="#"
            >
              <base-icon
                width="20"
                height="20"
                name="painel/chevron-right-icon"
              />
              <span class="c-sidebar__list-label">
                <strong>Outras customizações</strong>
              </span>
            </a>
          </li>
        </ul>
      </nav>

      <nav
        v-if="!customizationSelected || lengthCustomizations === 1"
        class="c-sidebar__nav"
      >
        <ul class="c-sidebar__list">
          <li class="c-sidebar__list-item c-sidebar__list-item--header">
            <base-icon width="24" height="24" name="painel/theme-icon" />
            <span class="c-sidebar__list-label">
              <strong>Tema atual</strong><br />
              {{ themeName }}
            </span>
            <a
              :href="`${wedSiteUrl}#/admin/tema`"
              class="button is-black is-outlined"
            >
              Alterar
            </a>
          </li>
        </ul>
        <ul v-if="lengthCustomizations !== 1" class="c-sidebar__list">
          <li
            v-for="(customization, index) in defaultCustomizations"
            :key="index"
            class="c-sidebar__list-item"
          >
            <a
              @click.prevent="showCustomization(customization)"
              href="#"
              class="c-sidebar__list-link"
            >
              <span
                class="c-sidebar__list-label c-sidebar__list-label--gapless-left"
              >
                {{ getNameCustomization(customization) }}
              </span>
              <base-icon
                width="20"
                height="20"
                name="painel/chevron-left-icon"
              />
            </a>
          </li>
        </ul>
      </nav>
      <SidebarOptions
        v-if="customizationSelected"
        :customization="customizationSelected"
      />
    </div>

    <div v-if="hasChanges" class="c-sidebar__footer">
      <button @click="openModalDiscard" type="button" class="button is-white">
        <base-icon width="24" height="24" name="painel/close-icon" />
        Descartar
      </button>
      <button @click="save" type="button" class="button is-primary">
        Salvar
      </button>
      <base-modal-bottom ref="discard" title="Descartar alterações">
        <template #btn-close-icon>
          <base-icon
            style="margin: 0 auto"
            width="16"
            height="16"
            name="painel/close-icon"
          />
        </template>

        <div class="has-text-centered">
          <h6 class="is-size-4 has-text-weight-bold">
            Deseja descartar as alterações?
          </h6>
          <p style="margin: 30px 0">
            Todas as alterações na customização do tema serão perdidas e<br />
            seu site voltará customização anterior.
          </p>
        </div>

        <div class="columns is-mobile is-centered">
          <div class="column is-narrow">
            <button
              @click="closeModalDiscard"
              style="width: 150px"
              type="button"
              class="button is-outlined is-black"
            >
              Cancelar
            </button>
          </div>
          <div class="column is-narrow">
            <button
              @click="discard"
              style="width: 150px"
              type="button"
              class="button is-primary"
            >
              Sim, descartar
            </button>
          </div>
        </div>
      </base-modal-bottom>
    </div>
  </aside>
</template>

<script>
import SidebarOptions from './SidebarOptions.vue'
import BaseModalBottom from '@/components/BaseModalBottom.vue'
import Legacy from '@/lib/api/Legacy'

import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    SidebarOptions,
    BaseModalBottom,
  },

  computed: {
    logonToken() {
      return this.$store.state.app.logonToken
    },

    ...mapGetters({
      wedSiteUrl: 'app/wedSiteUrl',
      themeName: 'theme/themeName',
      showPreviewTheme: 'theme/showPreviewTheme',
      defaultCustomizations: 'theme/defaultCustomizations',
      hasChanges: 'theme/hasChangesCustomizations',
    }),

    lengthCustomizations() {
      return this.defaultCustomizations?.length
    },
  },

  data() {
    return {
      customizationSelected: null,
    }
  },

  mounted() {
    if (this.lengthCustomizations === 1)
      this.showCustomization(this.defaultCustomizations[0])
  },

  methods: {
    ...mapActions({
      togglePreviewMode: 'theme/togglePreviewMode',
      saveCustomizations: 'theme/saveCustomizations',
      discardCustomizationsWithoutSaving:
        'theme/discardCustomizationsWithoutSaving',
      notification: 'app/setNotification',
    }),

    async save() {
      const response = await this.saveCustomizations()
      if (!response.error) {
        // force wedsite cache invalidation (SNS fails sometimes)
        const legacyApi = new Legacy(this.logonToken)
        legacyApi.clearWedsiteCache(this.logonToken.token_payload.wed_id)

        return this.notification({
          message: 'As alterações foram salvas com sucesso.',
          show: true,
        })
      }

      return this.notification({
        message: 'As alterações não foram salvas.',
        show: true,
        class: 'is-error',
      })
    },

    getNameCustomization(customization) {
      const group = customization?.group_customizations
      if (group && Array.isArray(group) && group.length === 1)
        return group[0]?.admin_options?.name
      return customization.name
    },

    showCustomization(customization) {
      this.customizationSelected = customization
    },

    openModalDiscard() {
      this.$refs.discard.open()
    },

    closeModalDiscard() {
      this.$refs.discard.close()
    },

    discard() {
      this.discardCustomizationsWithoutSaving()
      this.closeModalDiscard()
      this.notification({
        message: 'As alterações foram descartadas.',
        show: true,
      })
    },
  },
}
</script>

<style lang="scss">
.c-sidebar {
  position: relative;
  min-height: calc(100vh - 60px);
  width: 320px;
  z-index: 2;
  transition: 0.4s all ease-in-out;
  background-color: $white;
  border-right: 1px solid $gray-3;
  @media (max-width: 767px) {
    min-height: calc(100vh - 50px);
    width: 100%;
    &--preview-mode {
      position: fixed;
      top: 50px;
      right: auto;
      bottom: 0;
      left: auto;
      transform: translate(-100%, 0);
    }
  }
  &--static {
    position: static;
  }

  &__scroll-wrapper {
    height: calc(100vh - 125px);
    overflow-y: auto;
    @media (min-width: 767px) {
      height: calc(100vh - 135px);
    }
  }

  &__scroll-wrapper--space-top {
    padding-top: 97px;
    @media (min-width: 767px) {
      padding-top: 64px;
    }
  }

  &__nav {
    border-bottom: 1px solid $gray-3;
    @media (min-width: 767px) {
      border: 0;
    }
  }

  &__nav--fixed {
    @include position(absolute, 0, 0, auto, 0);
    z-index: 2;
    background-color: white;
  }

  &__list-item {
    display: flex;
    align-items: center;
    width: 100%;
    height: 48px;
    padding: 0 16px;
    color: $gray-6;
    border-bottom: 1px solid $gray-3;
    &:hover {
      background-color: $gray-2;
    }
    &:last-child {
      border-bottom: 0;
    }

    &--header {
      padding: 9px 16px;
      height: 48px;
      border-bottom: 1px solid $gray-3 !important;
      @media (min-width: 767px) {
        height: 64px;
      }
    }

    strong {
      color: $gray-6;
    }

    .button {
      min-width: initial;
      width: 115px;
      height: 34px;
      font-size: 14px;
    }
  }

  &__list-link {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 12px 0;
    color: $gray-6;
  }

  &__list-label {
    padding: 0 12px;
    flex: 1;
    &--gapless-left {
      padding-left: 0;
    }
  }

  &__footer {
    position: fixed;
    top: auto;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 16px;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: $white;
    @media (min-width: 767px) {
      position: absolute;
    }
    .button {
      min-width: initial;
      max-width: 190px;
      padding: 0 12px;
      margin-right: 6px;
      &:last-child {
        margin-right: 0;
      }
      @media (min-width: 767px) {
        flex: 1;
      }
      > svg {
        margin-right: 6px;
      }
    }
  }
}
</style>
